import { useState } from "react";

import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";

interface BulkRacksDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hallwayCode?: string;
  onSubmit: (count: number) => void;
  isLoading: boolean;
}

export function BulkRacksDialog({
  open,
  onOpenChange,
  hallwayCode,
  onSubmit,
  isLoading,
}: BulkRacksDialogProps) {
  const [count, setCount] = useState(20);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(count);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Crear Racks en Lote</DialogTitle>
            <DialogDescription>
              Genera múltiples racks para el pasillo{" "}
              <span className="font-mono font-medium">{hallwayCode}</span>
            </DialogDescription>
          </DialogHeader>

          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="count" className="text-right">
                Cantidad
              </Label>
              <Input
                id="count"
                type="number"
                min={1}
                max={30}
                value={count}
                onChange={(e) => setCount(parseInt(e.target.value) || 1)}
                className="col-span-3"
              />
            </div>

            <div className="rounded-lg bg-muted p-4">
              <p className="text-sm text-muted-foreground">
                Se crearán <span className="font-medium">{count}</span> racks
                con el formato:
              </p>
              <ul className="mt-2 space-y-1 font-mono text-sm">
                <li>{hallwayCode}-01</li>
                <li>{hallwayCode}-02</li>
                <li>...</li>
                <li>
                  {hallwayCode}-{String(count).padStart(2, "0")}
                </li>
              </ul>
            </div>
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              Cancelar
            </Button>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? "Creando..." : `Crear ${count} Racks`}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
